import { render, staticRenderFns } from "./ViewContentAction.vue?vue&type=template&id=33ba726e"
import script from "./ViewContentAction.vue?vue&type=script&lang=js"
export * from "./ViewContentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports